import React from "react";
import { PublicLayout } from "../components/PublicLayout";

const SECTIONS = [
  ["1. Information We Collect", "When you create an account we collect your name, email address, and a securely hashed password. The Service also processes IoT telemetry (voltage, current, power, temperature, air quality) and optional camera snapshots."],
  ["2. How We Use Information", "Account data is used solely to authenticate you and provide access to the dashboard. Telemetry is used to render live readings, charts and alerts. Snapshots are stored in your browser's local storage by default."],
  ["3. Cookies & Tokens", "We use httpOnly cookies and/or browser local storage to keep you signed in. These are essential for authentication and are not used for advertising or third-party tracking."],
  ["4. Data Storage", "User accounts are stored in a MongoDB database. Passwords are never stored in plain text - they are hashed with bcrypt. Telemetry shown in the preview is simulated and not personally identifiable."],
  ["5. Third-Party Services", "The Service may integrate with HiveMQ Cloud (MQTT), Grafana Cloud, ThingSpeak and Google Sheets. Their use of data is governed by their own privacy policies."],
  ["6. Data Retention", "You may delete your locally stored snapshots at any time from the Gallery. Account deletion requests can be made by contacting the administrator."],
  ["7. Your Rights", "You have the right to access, correct, or delete your personal data. Contact hhnk3693@gmail.com to exercise these rights."],
  ["8. Children's Privacy", "The Service is not directed at children under 13 and we do not knowingly collect their data."],
  ["9. Contact", "For privacy concerns, contact hhnk3693@gmail.com."],
];

export default function Privacy() {
  return (
    <PublicLayout>
      <section className="max-w-[820px] mx-auto px-4 sm:px-6 py-16">
        <span className="uppercase tracking-[0.2em] text-[10px] font-bold text-[var(--accent)]">Legal</span>
        <h1 className="font-heading font-black text-4xl tracking-tighter mt-2">Privacy Policy</h1>
        <p className="text-sm text-[var(--t2)] mt-2 font-mono">Last updated: June 2026</p>
        <div className="mt-8 space-y-7">
          {SECTIONS.map(([t, b]) => (
            <div key={t}>
              <h2 className="font-heading font-bold text-lg">{t}</h2>
              <p className="text-sm text-[var(--t2)] mt-2 leading-relaxed">{b}</p>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
